import { createSlice } from "@reduxjs/toolkit";
import {
  completeVotingAsync,
  fetchFeedbacksAsync,
} from "../actions/completeVotingAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  feedbacks: null,
  feedbacksLoading: false,
  feedbacksError: null,
};

const completeVotingSlice = createSlice({
  name: "completeVoting",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Complete voting cases
      .addCase(completeVotingAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(completeVotingAsync.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(completeVotingAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      // Fetch feedbacks cases
      .addCase(fetchFeedbacksAsync.pending, (state) => {
        state.feedbacksLoading = true;
        state.feedbacksError = null;
      })
      .addCase(fetchFeedbacksAsync.fulfilled, (state, action) => {
        state.feedbacksLoading = false;
        state.feedbacksError = null;
        state.feedbacks = action.payload;
      })
      .addCase(fetchFeedbacksAsync.rejected, (state, action) => {
        state.feedbacksLoading = false;
        state.feedbacksError = action.payload;
      });
  },
});

export const { resetState } = completeVotingSlice.actions;
export default completeVotingSlice.reducer;
